<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="`0 0 ${size} ${size}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      fill-rule="evenodd"
      :stroke="color"
      stroke-width="1.3"
    >
      <path stroke-linecap="round" d="M15.531 1v15" />
      <path stroke-linejoin="round" d="M15.062 8.5L1 16V1z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 17,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
